

import React from 'react';
import './contact.scss';

function Contact() {
  return (
    <div className="page-contact">
      <div className="contact-card">
        <div className="title">欢迎报名 👏 <br/>请添加老师微信进行付款报名</div>
        <div className="price"><span>￥</span>1998</div>
        <div className="content">
          <img src="images/qrcode.jpg" alt=""/>
          <p>Limi老师 微信号：lzhmeng</p>
          <ul>
            <li><span>1.</span>请扫码添加老师微信进行报名登记</li>
            <li><span>2.</span>报名后拉您进入学习群</li>
            <li><span>3.</span>请关注微信群通知</li>
            <li><span>4.</span>开课时间：2020-10-20，每周二、周四晚20:30-22:00</li>
            <li><span>5.</span>上课形式：CCTalk在线直播（请提前安装好软件，支持Windows、Mac上课）<br/>软件下载地址：<a href="https://www.cctalk.com/download" target="_blank">CCtalk</a></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Contact;